import { render } from "./PromptElements.vue?vue&type=template&id=014c7610&scoped=true&ts=true"
import script from "./PromptElements.vue?vue&type=script&lang=ts"
export * from "./PromptElements.vue?vue&type=script&lang=ts"

import "./PromptElements.vue?vue&type=style&index=0&id=014c7610&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-014c7610"]])

export default __exports__